import React from "react";
import { Link } from "react-router-dom";

const SectionLabel = ({ children }) => <span className="haven-label">{children}</span>;

export default function Canceled() {
  return (
    <main data-testid="canceled-page" className="haven-page-shell" style={{ paddingTop: 40 }}>
      <div className="haven-card" style={{ padding: 32 }}>
        <SectionLabel>No charge</SectionLabel>
        <h1 className="font-serif mt-3" style={{ fontSize: "clamp(32px, 4.6vw, 48px)", lineHeight: 1.1, color: "var(--ink)" }}>
          You stepped away. That's fine.
        </h1>
        <p style={{ marginTop: 12, color: "var(--ink-soft)", fontSize: 15, lineHeight: 1.7, maxWidth: 580 }}>
          Your card wasn't charged. The founding seat is still here when you're ready. If something on the page made you
          hesitate, tell us — we'd rather know than guess.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/join" className="haven-btn haven-btn-primary" data-testid="canceled-back-join">
            Back to founding tiers
          </Link>
          <Link to="/diagnose" className="haven-btn haven-btn-ghost" data-testid="canceled-diagnose">
            Try the free diagnostic instead
          </Link>
        </div>
      </div>
    </main>
  );
}
